const form_success = () => {

    let $popup = $('#email-success-popup');

    $popup.find('.js-popup-desc');

    document.addEventListener('wpcf7mailsent',(event) => {

        $popup.find('.js-popup-desc').text(event.detail.apiResponse.message);

        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: $popup[0].outerHTML,
            }
        })
    }, false)

};

form_success();